import React from 'react'
import { GeneratedClinicalNote } from '../../../../hooks/useClinicalNote/types'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@awell-health/design-system'

interface ClinicalNotesContextTabProps {
  clinicalNote: GeneratedClinicalNote
}

export const ClinicalNotesContextTab = ({ clinicalNote }: ClinicalNotesContextTabProps): JSX.Element => {
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Key</TableHead>
            <TableHead>Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {clinicalNote?.context.map(item => (
            <TableRow key={item.key}>
              <TableCell>{item.key}</TableCell>
              <TableCell>{item.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}

ClinicalNotesContextTab.displayName = 'ClinicalNotesContextTab'
